import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/shared/lib/apiClient";
import { raidContentKeys } from "@/shared/lib/queryKeys";

export function raidContentQueryOptions(date: string, raidId?: string) {
  return queryOptions({
    queryKey: raidContentKeys.byDate(date, raidId),
    queryFn: async () =>
      unwrap(
        await api.GET("/api/raids/content-options", {
          params: { query: { date, raidId } },
        }),
      ),
  });
}
